'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialXBlackAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.905 10.4695L21.3512 2H19.5869L13.1184 9.35244L7.95583 2H2L9.80863 13.1192L2 22H3.76429L10.591 14.2338L16.0442 22H22L13.905 10.4695ZM11.4877 13.2168L10.6954 12.1089L4.40053 3.30146H7.11084L12.1925 10.412L12.9815 11.5199L19.5861 20.7619H16.8758L11.4877 13.2168Z",
        fill: "#101010"
      }
    )
  }
);
const VpSocialXBlackAsset = forwardRef(SocialXBlackAsset);

export { VpSocialXBlackAsset as default };
